var _path;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMessages(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "messages_med",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24.258,
    height: 19.405,
    viewBox: "0 0 24.258 19.405",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Messages") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "messages-solid-2",
    d: "M2.426,0A2.428,2.428,0,0,0,0,2.426V9.7a2.428,2.428,0,0,0,2.426,2.426H3.639v1.819a.6.6,0,0,0,.334.542.614.614,0,0,0,.637-.057l3.074-2.3h5.659A2.428,2.428,0,0,0,15.768,9.7V2.426A2.428,2.428,0,0,0,13.342,0ZM13.342,13.342H9.7v1.213a2.428,2.428,0,0,0,2.426,2.426h4.446l3.074,2.3a.612.612,0,0,0,.637.057.6.6,0,0,0,.334-.542V16.98h1.213a2.428,2.428,0,0,0,2.426-2.426V7.277a2.428,2.428,0,0,0-2.426-2.426H16.98V9.7A3.64,3.64,0,0,1,13.342,13.342Z",
    fill: "inharit"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessages);
export default __webpack_public_path__ + "static/media/messages.a293321f45dc99e45a1099b22e1a3fdb.svg";
export { ForwardRef as ReactComponent };